"use client";

import { faArrowsRotate, faSlidersH } from "@fortawesome/pro-solid-svg-icons";
import { Button, SideDialog, useModal } from "@tosize/ui";
import { Fragment, type PropsWithChildren } from "react";
import { StyledLink } from "~/components/Link";
import { useQuery } from "~/hooks/useQuery";
import { FilterDialogContext } from "./FilterContext";

interface FilterButtonProps extends PropsWithChildren {
	title: string;
	productCountMessage: string;
	deleteFilterMessage: string;
}

export function FilterButton({
	title,
	children,
	deleteFilterMessage,
	productCountMessage,
}: FilterButtonProps) {
	const modal = useModal();

	const { router, pathname, searchParams, createUrl } = useQuery();

	const mode = searchParams.get("mode");
	const deleteFilterHref = { pathname, query: mode ? { mode: mode } : null };

	const onOpenChange = () => {
		modal.toggle();

		document.getElementById("products")?.scrollIntoView();

		if (!modal.open) {
			const defaultQuery = {
				utm_source: "categorypage",
				utm_medium: "filter",
				utm_campaign: "crs",
				utm_id: "general",
			};

			router.push(createUrl(defaultQuery));
		}
	};

	return (
		<Fragment>
			<Button
				id="filter-button"
				starticon={faSlidersH}
				onClick={onOpenChange}
				className="shrink-0 snap-start 2xl:px-6 2xl:py-3 2xl:text-base"
			>
				{title}
			</Button>

			<FilterDialogContext.Provider value={modal}>
				<SideDialog
					size="md"
					position="left"
					title={title}
					open={modal.open}
					onOpenChange={onOpenChange}
					footer={
						<div className="flex items-center justify-between">
							<StyledLink href={deleteFilterHref} variant="link" starticon={faArrowsRotate}>
								{deleteFilterMessage}
							</StyledLink>

							<Button color="success" className="ml-auto" onClick={onOpenChange}>
								{productCountMessage}
							</Button>
						</div>
					}
				>
					{children}
				</SideDialog>
			</FilterDialogContext.Provider>
		</Fragment>
	);
}
